(() => {
  if (window.SILCustomCartReady) return;
  window.SILCustomCartReady = true;
  const sessionCache = new Map();

  const readSavedDesign = (sessionKey) => {
    if (!sessionKey) return null;
    if (sessionCache.has(sessionKey)) return sessionCache.get(sessionKey);
    let saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(`sil-cart-design:${sessionKey}`) || 'null');
    } catch (error) {
      saved = null;
    }
    sessionCache.set(sessionKey, saved);
    return saved;
  };

  const hydrateCustomCartLines = (scope = document) => {
    const lines = [];
    if (scope.nodeType === 1 && scope.matches('[data-sil-custom-line]')) lines.push(scope);
    if (scope.querySelectorAll) lines.push(...scope.querySelectorAll('[data-sil-custom-line]'));

    lines.forEach((line) => {
      const sessionKey = line.dataset.silSessionKey;
      const saved = readSavedDesign(sessionKey);

      const remotePreview = line.dataset.silPreviewUrl || '';
      const imageUrl = remotePreview || (saved && saved.imageUrl) || '';
      const image = line.querySelector('[data-sil-cart-image]');
      const title = line.querySelector('[data-sil-cart-name]');

      if (imageUrl && image) {
        if (image.getAttribute('src') !== imageUrl) image.src = imageUrl;
        image.removeAttribute('srcset');
        image.width = image.width || 150;
        image.height = image.height || 150;
        image.style.objectFit = 'contain';
        image.style.background = '#fffdf8';
      }
      if (title && title.textContent !== 'Your Custom Tattoo') title.textContent = 'Your Custom Tattoo';
    });
  };

  const hydrate = () => hydrateCustomCartLines(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  else hydrate();

  document.addEventListener('shopify:section:load', (event) => hydrateCustomCartLines(event.target));
  document.querySelectorAll('cart-drawer, cart-notification, #main-cart-items').forEach((cartRoot) => {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) hydrateCustomCartLines(node);
      }));
    }).observe(cartRoot, { childList: true, subtree: true });
  });
})();
